export interface ReadRingStagingVersionsResponse {
  success: boolean;
  data: Array<RingVersionItem>;
  total: number;
}


export interface RingVersionItem {
  _id: string;
  version: string;
  versionIndex?: number;
  type: number;
  oemInfo: OemInfo;
  publishInfo: StagingVersionPublishInfo;
  status: number;
  vendorRings?: Array<string>;
  hasKit: boolean;
  lastModified?: string;
  stagingProfile?: Array<number>;
}

export interface OemInfo {
  id: number;
  name: string;
}

export interface StagingVersionPublishInfo {
  startDate: string;
  endDate?: string;
}

export enum RingVersionsMethods {
  READ_RECORDS = 'readRecords',
}
